/**
 * Message-kind helpers for the Sendbird open chats.
 */

/**
 * Whether a Sendbird message carries a file (photo, screenshot, video, PDF)
 * rather than text.
 *
 * Approved senders' TEXT messages get the custom highlighted renderer in
 * ChatContainer / TradingView Conversation / OptionsAcademyChat; their FILE
 * messages must fall through to Sendbird's own renderer, which draws
 * thumbnails and file cards and shows pending / failed upload states. The old
 * check (`message.type !== "image/png"`) only let PNG screenshots through, so
 * a JPEG photo picked on a phone was drawn as an empty text bubble
 * (TRAD-1302) — a FileMessage has no `message` text.
 *
 * `messageType` is set on every SDK message instance; `url` also survives the
 * UIKit's plain-object copy of a pending upload (SENDING_MESSAGE_START).
 *
 * @param {{ messageType?: string, url?: string } | null | undefined} message
 * @returns {boolean}
 */
export const isFileMessage = (message) =>
  !!message && (message.messageType === "file" || !!message.url);
